module.exports = __webpack_public_path__ + "img/image 06.be46d28d.jpg";